import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const r = await axios.post('/api/auth/google-callback', { session_id: sessionId });
        if (r.data.token) {
          localStorage.setItem('portal_token', r.data.token);
          await refreshUser();
          const user = r.data.user;
          if (user?.onboarding_complete === false && !user?.company_id) {
            navigate('/onboarding');
          } else if (['admin', 'manager', 'specialist'].includes(user?.role)) {
            navigate('/admin');
          } else {
            navigate('/platform');
          }
        } else {
          navigate('/login');
        }
      } catch (e) {
        console.error('Google auth failed:', e);
        navigate('/login');
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0f172a', fontFamily: "'Inter', sans-serif",
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px', height: '48px', margin: '0 auto 16px',
          border: '3px solid rgba(255,255,255,0.1)', borderTopColor: '#D4A017',
          borderRadius: '50%', animation: 'spin 0.8s linear infinite',
        }} />
        <p style={{ color: 'white', fontSize: '16px', fontWeight: 600 }}>Inloggen met Google...</p>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '13px', marginTop: '4px' }}>Even geduld</p>
      </div>
    </div>
  );
}
